import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/energy/energybanner.JPG';


const EnergyPageDatas = () => {


    return (
        <section style={{ marginTop: '40px' }}>
            <div className="container">


                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(236 115 34)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Energy & <span style={{ color: '#000' }}> Infrastructure</span>

                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    At DREBCON, we empower the Energy & Infrastructure sectors by addressing critical challenges in cybersecurity, regulatory compliance, and operational resilience, enabling organizations to safeguard critical assets, optimize performance, and drive sustainable innovation.
                                </p>
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Our expertise integrates advanced IT and OT security frameworks to protect SCADA, ICS, and IIoT environments, ensuring the resilience of power grids, smart infrastructure, and industrial automation systems. By embedding intelligent risk management systems and robust governance models, we mitigate cyber threats, enhance operational safety, and ensure compliance with CEA Cybersecurity Regulations, NCIIPC Guidelines, ISO 27019, and CERT-In directives.
                                </p>

                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    With a focus on secure, compliant, and scalable solutions, DREBCON enables energy providers, infrastructure developers, and smart grid operators to thrive in a rapidly evolving landscape while building trust, advancing security, and driving innovation in critical infrastructure ecosystems.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg1} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%', marginTop: '40px' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EnergyPageDatas;
